import React, { SVGProps } from 'react';

import { ReactComponent } from '../../assets/svg/close_24px.svg';

export default (props: SVGProps<any>): JSX.Element => <ReactComponent {...props} />;
